import { ApiBoardImageLoad } from "@/api";
import { canv } from "@/canv/global";
import {
    isImageFormatValid,
    isImageResolutionValid,
    isImageSizeValid,
    prepareImage,
} from "@/canv/utils";
import {
    IMAGE_FORMATS_READABLE,
    MAX_IMAGE_HEIGHT,
    MAX_IMAGE_SIZE_READABLE,
    MAX_IMAGE_WIDTH,
} from "@/constants";
import { GifWidget } from "@/elements/gif";
import { createImage, ImageWidget } from "@/elements/image";
import { SNACKBAR_TIME } from "@/elements/text/constants";
import { showSnackbar } from "@/snackbar/snackbar";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { applyValue } from "./applyValue";

export function handleMediaInputChange(
    options: widgetOption[],
    setNewOptions: (options: widgetOption[]) => void,
) {
    return async function handler(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];

        if (!file) {
            return;
        }

        if (!isImageSizeValid(file.size)) {
            showSnackbar(`Размер изображения превышает лимит в ${MAX_IMAGE_SIZE_READABLE}`, {
                duration: SNACKBAR_TIME,
                type: "warning",
            });
            return;
        }

        if (!isImageFormatValid(file.type)) {
            showSnackbar(`Допустимые форматы изображения: ${IMAGE_FORMATS_READABLE.join(", ")}`, {
                duration: SNACKBAR_TIME,
                type: "warning",
            });
            return;
        }

        const tempImage = await prepareImage(file);

        if (!tempImage) {
            return;
        }

        if (!isImageResolutionValid(tempImage.width, tempImage.height)) {
            showSnackbar(
                `Изображение превышает допустимое разрешение ${MAX_IMAGE_WIDTH} x ${MAX_IMAGE_HEIGHT}`,
                {
                    duration: SNACKBAR_TIME,
                    type: "warning",
                },
            );
            return;
        }

        const widgetsToUpdate: (GifWidget | ImageWidget)[] = [];

        if (
            options.some((option) => {
                const widget = canv.canvasController.FindByUID(option.UID);
                if (widget instanceof GifWidget || widget instanceof ImageWidget) {
                    widgetsToUpdate.push(widget);
                }
                return widget instanceof GifWidget && file.type !== "image/gif";
            })
        ) {
            showSnackbar("Вы можете заменить это изображение только на GIF", {
                duration: SNACKBAR_TIME,
                type: "warning",
            });
            return;
        }

        widgetsToUpdate.forEach((widget) => {
            widget.setLoading(true);
        });

        ApiBoardImageLoad(file)
            .then(async (json) => {
                const image = await createImage(json.path);

                widgetsToUpdate.forEach((widget) => {
                    widget.setLoading(false);
                });

                applyValue({ options, value: { src: json.path, obj: image }, setNewOptions });
            })
            .catch((err) => {
                showSnackbar(err.toString(), {
                    duration: SNACKBAR_TIME,
                    type: "warning",
                });

                widgetsToUpdate.forEach((widget) => {
                    widget.setLoading(false);
                });

                console.log("ошибка загрузки картинки", err);
            })
            .finally(() => {
                input.removeEventListener("change", handler);
                input.remove();
            });
    };
}
